module.exports = __webpack_public_path__ + "4c3be924764353cdffe7ed906deb487e.MP3";